<template>
  <div class="w-full p-6 bg-white rounded-lg shadow">
    <h4 class="text-base font-semibold">{{ title }}</h4>
    <p class="text-sm text-grey">{{ description }}</p>
    <div class="mt-4">
      <button class="sk-btn sk-btn-primary btn-border rounded-lg" @click="handleCheck">
        {{ buttonLabel }}
      </button>
    </div>
    <SKModal ref="checkDataModal" :title="modalTitle" closeButtonKey="apps.modals.cancel" actionButtonsPosition="center">
      <template #body>
        <div class="min-w-[320px]">
          <div v-if="modalWarnings.length" class="mb-4">
            <div v-for="(warning, index) in modalWarnings" :key="index" class="text-danger text-sm">
              {{ warning }}
            </div>
          </div>

          <div v-for="(section, index) in modalSections" :key="index" class="mb-4">
            <h5 class="text-sm font-semibold mb-2">{{ section.title }}</h5>
            <div v-if="section.rows.length === 0" class="text-sm text-grey">{{ $t('widgets.modal.no_data') }}</div>
            <div
              v-for="(row, rowIndex) in section.rows"
              :key="rowIndex"
              class="flex items-center justify-between py-1"
            >
              <div class="flex items-center gap-2">
                <img v-if="row.icon" :src="row.icon" class="w-5 h-5" />
                <span class="text-sm">{{ row.label }}</span>
              </div>
              <span class="text-sm font-medium">{{ row.value }}</span>
            </div>
          </div>

          <div v-if="modalNotes.length" class="text-xs text-grey">
            <div v-for="(note, index) in modalNotes" :key="index">{{ note }}</div>
          </div>
        </div>
      </template>
    </SKModal>
  </div>
</template>

<script>
import { getFormatInSelectFacilityLiftType } from '@/modules/Resorts/Helpers/facilityHelper'
import loader from '@/modules/Shared/Mixins/loader'
import SKModal from '@/modules/Shared/Components/modal/SKModal.vue'
import fetchFacilitiesMixin from './fetchFacilitiesMixin'
import checkFacilitiesModalMixin from './checkFacilitiesModalMixin'

export default {
  name: 'CheckLiftsByTypePanel',
  mixins: [loader, fetchFacilitiesMixin, checkFacilitiesModalMixin],
  components: {
    SKModal
  },
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    buttonLabel: {
      type: String,
      required: true
    },
    panelType: {
      type: String,
      required: true
    },
    selectedResortUuid: {
      type: String,
      required: true
    },
    resortInfo: {
      type: Object,
      default: null
    }
  },
  methods: {
    async handleCheck() {
      await this.checkFacilitiesData()
    },
    buildFacilitiesRows(facilities) {
      const rows = []
      const grouped = facilities.reduce((acc, facility) => {
        const key = facility.lift_type || 'unknown'
        if (!acc[key]) {
          acc[key] = { open: 0, total: 0, icon: null, label: key }
        }
        acc[key].total += 1
        if (this.isFacilityOpen(facility)) {
          acc[key].open += 1
        }
        const formatted = getFormatInSelectFacilityLiftType(facility.lift_type)
        if (formatted) {
          acc[key].icon = formatted.icon
          acc[key].label = formatted.label
        } else if (key === 'unknown') {
          acc[key].label = this.$t('widgets.modal.liftType.unknown')
        }
        return acc
      }, {})

      Object.values(grouped).forEach(group => {
        rows.push({ label: group.label, value: `${group.open} / ${group.total}`, icon: group.icon })
      })

      return rows
    },
    facilityTitle(type) {
      if (type === 'lift') {
        return this.$t('widgets.modal.facilities.lifts')
      }
      return this.$t('widgets.modal.facilities.default')
    }
  }
}
</script>

